import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
import { User, Building2, MapPin, Phone, Mail, CreditCard, Shield, Bell, Save, Edit, CheckCircle, TrendingUp, Package, DollarSign } from 'lucide-react';
interface AccountSettingsProps {
  onNavigate: (page: string) => void;
}
export function AccountSettings({
  onNavigate
}: AccountSettingsProps) {
  const [isEditing, setIsEditing] = useState(false);
  return <div className="space-y-6" data-id="element-268">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-269">
        <div data-id="element-270">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-271">Pengaturan Akun</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-272">
            Kelola informasi koperasi dan preferensi akun
          </p>
        </div>
        <Button variant={isEditing ? 'primary' : 'outline'} icon={isEditing ? <Save className="w-4 h-4" data-id="element-274" /> : <Edit className="w-4 h-4" data-id="element-275" />} onClick={() => setIsEditing(!isEditing)} data-id="element-273">
          {isEditing ? 'Simpan Perubahan' : 'Edit Profil'}
        </Button>
      </div>

      {/* Account Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-276">
        <Card className="p-4 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-277">
          <div className="flex items-center gap-3 mb-2" data-id="element-278">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-279">
              <Package className="w-5 h-5 text-white" data-id="element-280" />
            </div>
            <Badge variant="success" data-id="element-281">Aktif</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-282">Total Pesanan</p>
          <p className="text-3xl font-bold text-blue-900" data-id="element-283">156</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-284">
          <div className="flex items-center gap-3 mb-2" data-id="element-285">
            <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-286">
              <DollarSign className="w-5 h-5 text-white" data-id="element-287" />
            </div>
            <Badge className="bg-green-200 text-green-800" data-id="element-288">Baik</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-289">Total Belanja</p>
          <p className="text-3xl font-bold text-green-900" data-id="element-290">Rp 45Jt</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-291">
          <div className="flex items-center gap-3 mb-2" data-id="element-292">
            <div className="w-10 h-10 bg-violet-600 rounded-lg flex items-center justify-center" data-id="element-293">
              <CreditCard className="w-5 h-5 text-white" data-id="element-294" />
            </div>
            <Badge className="bg-violet-200 text-violet-800" data-id="element-295">75%</Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-296">Limit Kredit</p>
          <p className="text-3xl font-bold text-violet-900" data-id="element-297">Rp 50Jt</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-298">
          <div className="flex items-center gap-3 mb-2" data-id="element-299">
            <div className="w-10 h-10 bg-amber-600 rounded-lg flex items-center justify-center" data-id="element-300">
              <TrendingUp className="w-5 h-5 text-white" data-id="element-301" />
            </div>
            <Badge className="bg-amber-200 text-amber-800" data-id="element-302">+15%</Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-303">Penghematan</p>
          <p className="text-3xl font-bold text-amber-900" data-id="element-304">15%</p>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-305">
        {/* Profile Information */}
        <Card className="lg:col-span-2 p-6" data-id="element-306">
          <div className="flex items-center gap-3 mb-6" data-id="element-307">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center" data-id="element-308">
              <Building2 className="w-6 h-6 text-blue-600" data-id="element-309" />
            </div>
            <div data-id="element-310">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-311">
                Informasi Koperasi
              </h3>
              <p className="text-sm text-slate-500" data-id="element-312">
                Data profil dan kontak koperasi
              </p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-313">
            <div className="grid grid-cols-2 gap-4" data-id="element-314">
              <div data-id="element-315">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-316">
                  Nama Koperasi
                </label>
                <input type="text" value="Koperasi Maju Jaya" disabled={!isEditing} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600" data-id="element-317" />
              </div>
              <div data-id="element-318">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-319">
                  ID Koperasi
                </label>
                <input type="text" value="KOP-MJ-001" disabled className="w-full px-4 py-2.5 rounded-lg border border-slate-200 bg-slate-50 text-slate-600 font-mono" data-id="element-320" />
              </div>
            </div>

            <div data-id="element-321">
              <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-322">
                Alamat Lengkap
              </label>
              <textarea value="Jl. Raya Desa No. 123, RT 01/RW 02, Kec. Sukamaju, Kab. Bogor, Jawa Barat 16710" disabled={!isEditing} rows={3} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600 resize-none" data-id="element-323" />
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-324">
              <div data-id="element-325">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-326">
                  Nomor Telepon
                </label>
                <input type="tel" value="+62 812-3456-7890" disabled={!isEditing} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600" data-id="element-327" />
              </div>
              <div data-id="element-328">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-329">
                  Email
                </label>
                <input type="email" value="admin@majujaya.coop" disabled={!isEditing} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600" data-id="element-330" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-331">
              <div data-id="element-332">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-333">
                  Nama Ketua
                </label>
                <input type="text" value="Budi Santoso" disabled={!isEditing} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600" data-id="element-334" />
              </div>
              <div data-id="element-335">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-336">
                  Jumlah Anggota
                </label>
                <input type="number" value="450" disabled={!isEditing} className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-50 disabled:text-slate-600" data-id="element-337" />
              </div>
            </div>
          </div>
        </Card>

        {/* Credit & Security */}
        <div className="space-y-6" data-id="element-338">
          {/* Credit Info */}
          <Card className="p-6" data-id="element-339">
            <div className="flex items-center gap-3 mb-6" data-id="element-340">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center" data-id="element-341">
                <CreditCard className="w-6 h-6 text-green-600" data-id="element-342" />
              </div>
              <div data-id="element-343">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-344">
                  Limit Kredit
                </h3>
                <p className="text-sm text-slate-500" data-id="element-345">Informasi kredit</p>
              </div>
            </div>

            <div className="space-y-4" data-id="element-346">
              <div data-id="element-347">
                <div className="flex justify-between items-center mb-2" data-id="element-348">
                  <span className="text-sm text-slate-600" data-id="element-349">Total Limit</span>
                  <span className="font-bold text-slate-900" data-id="element-350">
                    Rp 50.000.000
                  </span>
                </div>
                <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-351">
                  <div className="h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full" style={{
                  width: '75%'
                }} data-id="element-352"></div>
                </div>
                <div className="flex justify-between items-center mt-2" data-id="element-353">
                  <span className="text-xs text-slate-500" data-id="element-354">
                    Terpakai: Rp 37.5Jt
                  </span>
                  <span className="text-xs font-bold text-green-600" data-id="element-355">75%</span>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-200" data-id="element-356">
                <div className="flex justify-between items-center mb-2" data-id="element-357">
                  <span className="text-sm text-slate-600" data-id="element-358">Outstanding</span>
                  <span className="font-bold text-amber-600" data-id="element-359">
                    Rp 12.500.000
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-360">
                  <span className="text-sm text-slate-600" data-id="element-361">Jatuh Tempo</span>
                  <Badge variant="warning" data-id="element-362">NET 30</Badge>
                </div>
              </div>
            </div>
          </Card>

          {/* Security */}
          <Card className="p-6" data-id="element-363">
            <div className="flex items-center gap-3 mb-6" data-id="element-364">
              <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center" data-id="element-365">
                <Shield className="w-6 h-6 text-violet-600" data-id="element-366" />
              </div>
              <div data-id="element-367">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-368">Keamanan</h3>
                <p className="text-sm text-slate-500" data-id="element-369">Password & 2FA</p>
              </div>
            </div>

            <div className="space-y-3" data-id="element-370">
              <button className="w-full flex items-center justify-between p-3 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-371">
                <span className="text-sm font-medium text-slate-900" data-id="element-372">
                  Ubah Password
                </span>
                <Edit className="w-4 h-4 text-slate-400" data-id="element-373" />
              </button>
              <button className="w-full flex items-center justify-between p-3 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-374">
                <div className="flex items-center gap-2" data-id="element-375">
                  <span className="text-sm font-medium text-slate-900" data-id="element-376">
                    Two-Factor Auth
                  </span>
                  <Badge variant="success" data-id="element-377">Aktif</Badge>
                </div>
                <CheckCircle className="w-4 h-4 text-green-600" data-id="element-378" />
              </button>
            </div>
          </Card>

          {/* Notifications */}
          <Card className="p-6" data-id="element-379">
            <div className="flex items-center gap-3 mb-6" data-id="element-380">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center" data-id="element-381">
                <Bell className="w-6 h-6 text-blue-600" data-id="element-382" />
              </div>
              <div data-id="element-383">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-384">Notifikasi</h3>
                <p className="text-sm text-slate-500" data-id="element-385">Preferensi alert</p>
              </div>
            </div>

            <div className="space-y-3" data-id="element-386">
              <label className="flex items-center justify-between cursor-pointer" data-id="element-387">
                <span className="text-sm text-slate-700" data-id="element-388">Email Pesanan</span>
                <input type="checkbox" defaultChecked className="rounded" data-id="element-389" />
              </label>
              <label className="flex items-center justify-between cursor-pointer" data-id="element-390">
                <span className="text-sm text-slate-700" data-id="element-391">SMS Pengiriman</span>
                <input type="checkbox" defaultChecked className="rounded" data-id="element-392" />
              </label>
              <label className="flex items-center justify-between cursor-pointer" data-id="element-393">
                <span className="text-sm text-slate-700" data-id="element-394">WhatsApp Update</span>
                <input type="checkbox" className="rounded" data-id="element-395" />
              </label>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}